/** Buckets API endpoints, merged into the platform API client. */
export const bucketsApiEndpoints: Record<string, string> = {
  orgBuckets: "/ext/buckets/buckets/",
  createOrgBucket: "POST:/ext/buckets/buckets/",
  orgBucket: "/ext/buckets/buckets/:pk/",
  updateOrgBucket: "PATCH:/ext/buckets/buckets/:pk/",
  deleteOrgBucket: "DELETE:/ext/buckets/buckets/:pk/",
  orgBucketGrants: "PUT:/ext/buckets/buckets/:pk/grants/",
  orgBucketPassOn: "POST:/ext/buckets/buckets/:pk/pass-on/",
};
